module.exports = __webpack_public_path__ + "static/media/tourney.d4bc75f5.svg";